import { useRequest } from 'ahooks';
import { getWordCloud } from '@axios/api'

function useGetWordCloud(){
  const {  data:wordCloudData, loading:wordCloudLoading,runAsync:getWordCloudAction } = useRequest(
    async (params) => {
      try {
        const resp = await getWordCloud({
          ...params
        });
        return resp?.data ?? undefined
      } catch (error) {
        // message.error('获取知识点失败！');
        return undefined;
      }
    },
    {
      debounceWait: 40,
      manual: true,
    },
  );

    return {
      wordCloudData,
      wordCloudLoading,
      getWordCloudAction
    
    }
}

export default useGetWordCloud